import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "base_screen_header"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1);

const _hoisted_4 = {
  class: "dialog-footer"
};
import { ref, reactive, watch } from "vue";
import { $msg } from "@ui/msg";
import DataCollectTable from "@com/table/DataCollectTable.vue";
import { OP_KEY, COLUMN_TYPE, OPERATIONS } from "@com/table/tableOperations";
import { Search } from "@element-plus/icons-vue";
import $ from "@util/base";
import api from "@api/additionalFees";
export default {
  __name: 'ChooseAdditional',
  emits: ["chooseAdditional"],

  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;
    const dialogVisible = ref(false);
    const name = ref("");
    const total = ref(0);
    const data = ref([]);
    const config = {
      showSelection: true,
      showIndex: true,
      column: [{
        label: '一级名称',
        prop: 'groupName'
      }, {
        label: '二级名称',
        prop: 'extraName'
      }, {
        label: '费用金额',
        prop: 'extraPrice'
      }, {
        label: '供应商',
        prop: 'supplier'
      }, {
        label: '费用详情',
        prop: 'picUrl',
        type: COLUMN_TYPE.picture,
        width: 100
      }]
    };
    const params = ref({
      groupName: null,
      extraName: null,
      page: null,
      size: null
    });

    function pageChange(key, val) {
      params.value[key] = val;
      getData();
    }

    getData();

    function getData() {
      api.list(params.value, val => {
        total.value = val.total;
        data.value = val.itemList;
      });
    }

    const tableRef = ref(null);

    function getSelection() {
      let data = tableRef.value.getSelectData();
      data = data.map(item => {
        return item.code;
      });
      return data;
    }

    function getSelectData() {
      let data = tableRef.value.getSelectData();
      return data;
    }

    function clearSelection() {
      tableRef.value.clearSelection();
    }

    function empty() {
      total.value = 0;
      data.value = [];
    }

    function saveAdditional() {
      let data = getSelectData();

      if ($.isEmpty(data)) {
        $msg.error("请勾选需要添加的附加费用");
      } else {
        emit("chooseAdditional", data);
        close();
      }
    }

    function show(val) {
      dialogVisible.value = true;

      if (!tableRef.value) {
        return;
      }

      clearSelection();
    }

    function close() {
      dialogVisible.value = false;
    }

    __expose({
      show
    });

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogVisible.value = $event),
        title: "添加附加费用",
        width: "800px",
        class: "base_dialog home_page_dialog"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_button, {
          onClick: saveAdditional,
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: close
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_form, {
          inline: true,
          class: "base_search_form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: params.value.groupName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.value.groupName = $event),
              "onKeyup[native]": getData,
              onChange: getData,
              placeholder: "一级名称",
              clearable: "",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: params.value.extraName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => params.value.extraName = $event),
              "onKeyup[native]": getData,
              onChange: getData,
              placeholder: "二级名称",
              clearable: "",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          })]),
          _: 1
        })]), _createVNode(DataCollectTable, {
          ref_key: "tableRef",
          ref: tableRef,
          data: data.value,
          config: config,
          total: total.value,
          isRoute: false,
          onPageChange: pageChange
        }, null, 8, ["data", "total"])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};